// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"AppLoader_loader_container__HZGLh","loader":"AppLoader_loader__rD3TW","loading":"AppLoader_loading__bOcxk","spin":"AppLoader_spin__X_aKo"};